import { IntervalAction } from './IntervalAction';

export class EmptyAction extends IntervalAction {
  beginImpl(): void {}

  endImpl(): void {}

  updateImpl(_dt: number): void {}
}
